(function () {
  'use strict';

  const header = document.querySelector('.wls-header');
  if (!header) return;

  let ticking = false;

  function syncHeader() {
    header.classList.toggle('is-studio-compact', window.scrollY > 18);
    ticking = false;
  }

  syncHeader();
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(syncHeader);
  }, { passive: true });
})();

(function () {
  'use strict';

  const mobileQuery = window.matchMedia('(max-width: 767px)');
  const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  let ticking = false;

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function syncRoutineSteps() {
    const enabled = mobileQuery.matches && !reduceMotionQuery.matches;

    document.querySelectorAll('.wls-routine-steps[data-layout="studio-grid"]').forEach(function (section) {
      const slider = section.querySelector('.wls-routine-steps__slider');
      const track = section.querySelector('.wls-routine-steps__slider-content');
      if (!slider || !track) return;

      if (!enabled) {
        track.scrollLeft = 0;
        return;
      }

      const stickyTop = parseFloat(window.getComputedStyle(track).top) || 0;
      const sliderRect = slider.getBoundingClientRect();
      const travel = Math.max(1, slider.offsetHeight - track.offsetHeight - stickyTop);
      const progress = clamp((stickyTop - sliderRect.top) / travel, 0, 1);
      const horizontalTravel = Math.max(0, track.scrollWidth - track.clientWidth);

      track.scrollLeft = horizontalTravel * progress;
    });

    ticking = false;
  }

  function requestRoutineSync() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(syncRoutineSteps);
  }

  syncRoutineSteps();
  window.addEventListener('scroll', requestRoutineSync, { passive: true });
  window.addEventListener('resize', requestRoutineSync, { passive: true });
  document.addEventListener('shopify:section:load', requestRoutineSync);
})();
